module.exports = __webpack_public_path__ + "static/media/mid.cc5b470a.png";